/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { VApplication } from '@/application';
import { toHeaderCase } from 'js-convert-case';
import config from '../config/preview.config.json';

export interface IFormatComplFormMethods extends IPluginMethodMap {
  getFormatComplFormSync(args: any): any;
}

export class FormatComplFormService implements IAgentPlugin {
  readonly methods: IFormatComplFormMethods;

  constructor() {
    this.methods = {
      getFormatComplFormSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    let _compForm = this.FormatComplForm(args);
    return {
      ...config,
      fields: _compForm,
    };
  }

  private FormatComplForm(data: any) {
    let _appCard: any = [];
    data &&
      Array.isArray(data) &&
      data.length &&
      data.forEach((item: any) => {
        _appCard.push(
          {
            type: 'sectionTitle',
            compProps: {
              id: item?.name,
              label: item?.name,
            },
          },
          {
            type: 'fileDropZone',
            compProps: {
              id: `${item?.id}-evidence`,
              label: 'Evidence',
              required: true,
              maxFiles: 1,
            },
          },
          {
            type: 'datepicker',
            compProps: {
              id: `${item?.id}-validFrom`,
              label: 'Valid From',
              required: true,
            },
          },
          {
            type: 'datepicker',
            compProps: {
              id: `${item?.id}-validUntil`,
              label: 'Valid Until',
              required: false,
            },
          }
        );
      });

    return _appCard;
  }
}
